import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";
import BaseModel from "../Models/BaseModel";
import NOTAMActiveState from "./NOTAMActiveState";

const NOTAMDataMappings = {
	dateCreate: "properties.CreationDate",
	dateStart: "properties.StartDate",
	dateEnd: "properties.EndDate",

	id2: "properties.ID2",
	type: "properties._type",
	area: "properties.area",
	subarea: "properties.SubArea",
	message: "properties.Message",
	country: "properties.StateName",
	countryCode3: "properties.StateCode",
	status: "properties.LW",
	location: "properties.location",
	entity: "properties.entity",
	icao: "properties.isICAO",
	qcode: "properties.Qcode",
	modifier: "properties.Modifier",
	condition: "properties.Condition"
};
class NOTAM extends BaseModel {
	constructor(arcgisFeatureData) {
		super(NOTAMDataMappings, {});

		this.arcgisData = arcgisFeatureData;
		this.geojsonData = arcgisToGeoJSON(this.arcgisData);
		this.data = this.geojsonData;

		if (this.data.geometry && this.data.geometry.type === "Point") {
			this.data.geometry.coordinates[0] = this.lng;
			this.data.geometry.coordinates[1] = this.lat;
		}

		this._activeState = this._calcActiveState();
		this.data.properties.color = this.color;

		this.visible = true;
	}

	get area() {
		return this.get("area");
	}

	get subarea() {
		return this.get("subarea");
	}

	get id2() {
		return this.get("id2");
	}

	get dateStart() {
		return this.get("dateStart");
	}

	get dateEnd() {
		return this.get("dateEnd");
	}

	get countryCode3() {
		return this.get("countryCode3");
	}

	get country() {
		return this.get("country");
	}

	get qcode() {
		return this.get("qcode");
	}

	get activeState() {
		return this._activeState;
	}

	get activeStateState() { // the table display name for the active state.
		return NOTAM.getActiveStateStateName(this.activeState);
	}

	get color() {
		return NOTAM.getActiveStateColor(this.activeState);
	}

	get message() {
		return this.get("message");
	}

	get location() {
		return this.get("location");
	}

	_calcActiveState() {
		const cur = Date.now();
		if (cur > this.dateEnd) {
			return NOTAMActiveState.PAST;
		}
		else if (cur < this.dateStart) {
			return NOTAMActiveState.FUTURE;
		}
		return NOTAMActiveState.CURRENT;
	}

	get uniqId() {
		return this.data.properties.GlobalID + this.data.properties.ID1 + this.data.properties.ID2;
	}

	get globalId() {
		return this.data.properties.GlobalID;
	}

	asFeature() {
		return this.data;
	}
}
NOTAM.getActiveStateColor = (state) => {
	if (state === NOTAMActiveState.PAST) {
		return "grey";
	}
	else if (state === NOTAMActiveState.CURRENT) {
		return "red";
	}
	else if (state === NOTAMActiveState.FUTURE) {
		return "orange";
	}
};
NOTAM.getActiveStateStateName = (state) => {
	if (state === NOTAMActiveState.PAST) {
		return "Past";
	}
	else if (state === NOTAMActiveState.CURRENT) {
		return "Current";
	}
	else if (state === NOTAMActiveState.FUTURE) {
		return "Future";
	}
};

export default NOTAM;
